<ui-grid [data]="data$ | async"
          [loading]="loading$ | async"
          [multiPageSelect]="true">

    <ui-grid-header [search]="true">
    </ui-grid-header>

    <ui-grid-column [title]="'role_users_grid_type' | translate"
                    [resizeable]="false"
                    width="15%"
                    property="type">
        <ui-grid-dropdown-filter [items]="typeList"
                                 [value]="defaultType">
        </ui-grid-dropdown-filter>
        <ng-template let-entry="data">
                <mat-icon *ngIf="UserIconMap[entry.type].svgIcon; else userMatIcon"
                          [svgIcon]="UserIconMap[entry.type].svgIcon">
                </mat-icon>
                <ng-template #userMatIcon>
                    <mat-icon>{{ UserIconMap[entry.type].matIcon }}</mat-icon>
                </ng-template>
            </ng-template>
    </ui-grid-column>

    <ui-grid-column [sortable]="true"
                    [searchable]="true"
                    [title]="'role_users_grid_username' | translate"
                    [resizeable]="false"
                    property="userName"
                    width="30%">
    </ui-grid-column>

    <ui-grid-column [sortable]="true"
                    [searchable]="true"
                    [title]="'role_users_grid_email' | translate"
                    [resizeable]="false"
                    property="emailAddress"
                    width="55%">
    </ui-grid-column>

    <ui-grid-footer [length]="total$ | async"
                    [pageSize]="pageSize"
                    [pageSizes]="pageSizes">
    </ui-grid-footer>

</ui-grid>

<mat-card *ngIf="isInConflictingState$ | async as isInConflictingState"
          [uiScrollIntoView]="isInConflictingState"
          color="warn">
    <p translate>
        role_users_modal_conflict_warning
    </p>
</mat-card>
